<div class="engie-login">
  <div class="engie-accesos">
        <div class="container">
              <div class="row items-accesos">
                <div class="box-login">
                  <h3>PORTAL DE GESTIÓN DE</h3>
                  <h2>TERCEROS</h2>
                </div>
              </div>
        </div>
  </div>
</div>
<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
<div class="engie-form">
  <div class="engie-accesos">
    <div class="row">
      <div class="engie-datos">
        <div class="row">
          <div class="col-md-12">
            <img class="engie-q1" src="./assets/img/Logo_w.svg">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h3 class="engie-q2">Recuperar contraseña</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>CORREO</mat-label>
              <input matInput type="email" [(ngModel)]="email" name="email" required />
            </mat-form-field>            
          </div>
        </div>
      
        <div class="row">
          <div class="col-md-12 pad-25">
            <a class="btn btn-blanco"
              mat-raised-button
              (click)="back()"
              ><mat-icon>arrow_back</mat-icon> Cancelar</a>
            <button type="submit" [disabled]="modelForm.invalid" class="btn btn-azul" mat-button><mat-icon>send</mat-icon> Recuperar contraseña</button>
          </div>           
        </div>  
      </div>
    </div>
  </div>

</div>

</form>